export const ADMINISTRATORS_TRANSLATE = {
    administrators: {
        breadcrumbName: "Administrators",
        messages: {
            create: "Administrator created successfully",
            update: "Administrator updated successfully",
            delete: "Administrator deleted successfully",
        },
        dialog: {
            delete: {
                title: "Delete",
                body: "Delete administrator \"{{administrator.name}}\"?",
                actions: {
                    primary: "Yes, delete",
                    secondary: "Back",
                }
            }
        },
        fields: {
            name: {
                label: "Name",
                placeholder: "Enter the name here",
            },
            email: {
                label: "Email",
                placeholder: "Enter the email here"
            },
            password: {
                label: "Password",
                placeholder: "Enter the password here"
            },
            passwordConfirmation: {
                label: "Password Confirmation",
                placeholder: "Enter the same password here"
            },
        }
    }
}
